import * as React from 'react';
export const allpaySvg = React.forwardRef(function allpaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 7.734c-.4.52-1.357 1.705-2.066 2.312-.616.55-1.202.867-1.973.867-.339 0-1.048-.115-1.202-.838h-.03c0 .015-.008.022-.016.03-.008.006-.015.013-.015.028a2.908 2.908 0 0 1-2.066.838c-1.202 0-1.572-.462-1.665-.867h-.03c-.186.231-.925.838-1.881.838-.278 0-1.08-.058-1.233-.838h-.031c0 .029-.03.058-.03.058-.402.404-1.05.81-2.005.838h-.061C.154 11 0 10.19 0 9.815c0-.376.4-2.11 1.973-3.006.925-.52 2.158-.78 3.884-.809h.463c.03 0 .03.029.03.029L5.24 9.67c-.153.49-.06.664.155.664.308 0 .863-.404 1.202-.809a3.15 3.15 0 0 0 .247-.491l.493-1.619C7.791 5.997 9.077 6 9.416 6h.018c.03 0 .03.029.03.029-.03.087-.154.462-.308.983-.308.982-.74 2.34-.77 2.427a2.66 2.66 0 0 1-.04.169c-.044.175-.098.39-.053.496.062.174.216.26.462.26.432 0 1.11-.289 1.603-.925.185-.202.309-.433.37-.664.155-.405.432-1.33.432-1.33.454-1.419 1.74-1.417 2.079-1.416h.017c.031 0 .031.029.031.029-.04.168-.452 1.503-.764 2.514-.171.556-.313 1.015-.346 1.127-.123.52-.03.665.154.665.216 0 .555-.202.771-.376.617-.49 1.357-1.387 2.035-2.254H16ZM3.977 8.746l.647-2.081c-.77.115-2.281.636-2.99 2.832-.154.55-.123.896.37.896.431 0 1.11-.289 1.603-.925.154-.202.277-.462.37-.722Z',
    }),
  );
});
allpaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var allpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'allpay',
  svg: allpaySvg,
};
